module.exports = {
    locations: [
        {
            "title": {
                "en": "Blackpool",
                "cym": "Blackpool"
            },

            "modalTitle": {
                "en": "at Blackpool",
                "cym": "o Blackpool"
            },

            "existingVideoId": "718214474",
            "proposedVideoId": "718215332",
            "lat": 53.816950,
            "lng": -3.055990
        },

        {
            "title": {
                "en": "Douglas",
                "cym": "Douglas"
            },

            "modalTitle": {
                "en": "at Douglas",
                "cym": "o Douglas"
            },

            "existingVideoId": "718214520",
            "proposedVideoId": "718215363",
            "lat": 54.142605,
            "lng": -4.466485
        },

        {
            "title": {
                "en": "Moel Famau",
                "cym": "Moel Famau"
            },

            "modalTitle": {
                "en": "at Moel Famau",
                "cym": "o Moel Famau"
            },

            "existingVideoId": "718214564",
            "proposedVideoId": "718215401",
            "lat": 53.154495,
            "lng": -3.255903
        },

        {
            "title": {
                "en": "Rhyl Beach",
                "cym": "Traeth y Rhyl"
            },

            "modalTitle": {
                "en": "at Rhyl Beach",
                "cym": "o Traeth y Rhyl"
            },

            "existingVideoId": "718214608",
            "proposedVideoId": "718215432",
            "lat": 53.325460,
            "lng": -3.488189
        },

        {
            "title": {
                "en": "Great Orme",
                "cym": "Pen y Gogarth"
            },

            "modalTitle": {
                "en": "at Great Orme",
                "cym": "o Pen y Gogarth"
            },

            "existingVideoId": "718214642",
            "proposedVideoId": "718215474",
            "lat": 53.332744,
            "lng": -3.850811
        },

        {
            "title": {
                "en": "Yr Wyddfa",
                "cym": "Yr Wyddfa"
            },

            "modalTitle": {
                "en": "o'r Yr Wyddfa",
                "cym": "o'r Yr Wyddfa"
            },

            "existingVideoId": "718214691",
            "proposedVideoId": "718215526",
            "lat": 53.068480,
            "lng": -4.076018
        },

        {
            "title": {
                "en": "Parys Mountain",
                "cym": "Mynydd Parys"
            },

            "modalTitle": {
                "en": "at Parys Mountain",
                "cym": "o Mynydd Parys"
            },

            "existingVideoId": "718214738",
            "proposedVideoId": "718215582",
            "lat": 53.383295,
            "lng": -4.349348
        },

        {
            "title": {
                "en": "Point Lynas Lighthouse",
                "cym": "Goleudy Trwyn Eilian"
            },

            "modalTitle": {
                "en": "at Point Lynas Lighthouse",
                "cym": "o'r Goleudy Trwyn Eilian"
            },

            "existingVideoId": "718214827",
            "proposedVideoId": "718215673",
            "lat": 53.415920,
            "lng": -4.289512
        },

        {
            "title": {
                "en": "Bull Bay",
                "cym": "Porth Llechog",
            },

            "modalTitle": {
                "en": "at Bull Bay",
                "cym": "o Porth Llechog"
            },

            "existingVideoId": "718214779",
            "proposedVideoId": "718215632",
            "lat": 53.416944,
            "lng": -4.362252
        },

        {
            "title": {
                "en": "Penmon Point",
                "cym": "Penmon Point",
            },

            "modalTitle": {
                "en": "at Penmon Point",
                "cym": "o Penmon Point"
            },

            "existingVideoId": "718214853",
            "proposedVideoId": "718215711",
            "lat": 53.310861,
            "lng": -4.041043
        }
    ]
};